import React, { Component } from 'react';
import { Singleton } from '../../../js/Singleton';
import { arrowBack } from '../../../Images/GenericSVG';

export default class IntegrationInfoLog extends Component{
  constructor(props){
    super(props);
    this.language = new Singleton();
  }
  render() {
    return (
      <div className="exclusiveCallBackContainer">
        <div className="headerLogIntegration">
          <div className="buttonCircleConnectIntegration" onClick={()=>this.props.backToIntegration()}>{arrowBack}</div>
          <p className="titleLogIntegration">{this.language.getText("GUIIntegrationLog")}</p>
        </div>
        <label spellCheck={false} className="logContainer">
        {this.props.integrationLog.map((item, index)=>
          <div key={index}>
            {item}
          </div>)}
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/IntegrationInfoLog.jsx